import React, { useEffect, useRef } from 'react'
import { useTranslation } from 'react-i18next'
import Text from '../../../../../elements/Typo/Text'
import { trackEvent } from '../../../../../_common/functions'

interface InsightsDialogProps {
    buttonRef: any
    dialogData: any
    toggleMenu: (btn: any, e?: any, type?: 'info' | 'experiment') => void
}
const InsightsDialog = (props: InsightsDialogProps) => {
    const { t } = useTranslation()
    const { buttonRef, dialogData, toggleMenu } = props
    const dialogRef = useRef<HTMLDivElement>(null) // Create a ref for the dialog

    useEffect(() => {
        const handleClickOutside = (event: MouseEvent) => {
            if (dialogRef.current && !dialogRef.current.contains(event.target as Node)) {
                trackEvent('exec_dashboard_learning_insight_dialog_closed', { experiment_literal: dialogData?.experiment_literal })
                toggleMenu(null, null, 'info')
            }
        }

        // Attach the event listener
        document.addEventListener('mousedown', handleClickOutside)
        return () => {
            // Clean up the event listener on component unmount
            document.removeEventListener('mousedown', handleClickOutside)
        }
    }, [buttonRef, toggleMenu, dialogData])

    const getPositionStyles = () => {
        if (buttonRef) {
            const rect = buttonRef.getBoundingClientRect()
            const top = rect.top + window.scrollY

            if (rect.left + 500 > window.innerWidth) {
                return {
                    top,
                    right: window.innerWidth - rect.right,
                }
            } else {
                return {
                    top,
                    left: rect.left,
                }
            }
        }
        return { top: 0, left: 0 }
    }

    return (
        <div ref={dialogRef} className="absolute z-50 bg-white rounded-[0.542rem] border border-slate-300 shadow-lg ml-5 -mt-3" style={getPositionStyles()}>
            <div className="w-full ">
                <div className="p-[0.625rem] h-full">
                    {/* Optional close button */}

                    <div className="flex justify-between items-center">
                        <Text size="14" className="font-medium">
                            {dialogData?.experiment_name}
                        </Text>
                        <button
                            type="button"
                            onClick={() => {
                                trackEvent('exec_dashboard_learning_insight_dialog_closed', { experiment_literal: dialogData?.experiment_literal })
                                toggleMenu?.(null, null, 'info')
                            }}
                            className="text-2xl "
                        >
                            <img src="/close.svg" alt={t('close')} />
                        </button>
                    </div>
                    <div className="h-full rounded-[0.625rem] bg-[#EFF2F799] py-[0.417rem] px-[0.625rem]">
                        <ul className="list-disc pl-5 space-y-1 text-[12px]">
                            {dialogData.blocking_factors_formated?.map((it: string) => (
                                <li key={it}>{it}</li>
                            ))}
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default InsightsDialog
